import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "bootstrap/dist/css/bootstrap.css";
import { Auth0Provider } from "@auth0/auth0-react";

const domain = "dev-lp5nzyo6.us.auth0.com";
const clientId = "Xiffp8iaUi1sXoJaisB8hmAcqgSLZwOn";

ReactDOM.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    redirectUri={"https://surveying-systems.tn/gest-cat"}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);
